export const JWT_API = {
    secret: 'SECRET-KEY',
    timeout: '1 days'
};

// basename: only at build time to set, and don't add '/' at end off BASENAME for breadcrumbs, also don't put only '/' use blank('') instead
export const BASE_PATH = process.env.REACT_APP_BASEPATH;
export const DASHBOARD_PATH = '/dashboard/default';
export const APP_NAME = 'GESTOP';
export const APP_VERSION = 'v2.0';
export const APP_DEPLOY_YEAR = 2024;
export const APP_PROVIDER_NAME = 'Consult.IT, Lda.';
export const APP_PROVIDER_URL = 'https://consultit-angola.com/';

const config = {
    fontFamily: `'Roboto', sans-serif`,
    borderRadius: 8,
    outlinedFilled: true,
    navType: 'light', // light, dark
    presetColor: process.env.REACT_APP_THEME, // default, theme1, theme2, theme3, theme4, theme5, theme6
    locale: 'pt', // 'en' - English, 'pt' - Portuguese, 'es' - Spanish
    rtlLayout: false,
    container: false,
    dndMode: false,
    notificationChannels: ['internal']
};

export default config;
